import { RawAxiosRequestHeaders } from 'axios';

export const createETagHeader = (eTag: string): RawAxiosRequestHeaders => ({
  'if-none-match': eTag.trim(),
});
